var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 3.69813C28.8844 4.1875 27.6956 4.51187 26.4562 4.66937C27.7312 3.90812 28.7044 2.71187 29.1619 1.27C27.9731 1.97875 26.6606 2.47938 25.2619 2.75875C24.1331 1.55688 22.5244 0.8125 20.7694 0.8125C17.3644 0.8125 14.6231 3.57625 14.6231 6.96438C14.6231 7.45188 14.6644 7.92062 14.7656 8.36687C9.6525 8.1175 5.12813 5.66688 2.08875 1.93375C1.55812 2.85438 1.24688 3.90812 1.24688 5.0425C1.24688 7.1725 2.34375 9.06063 3.97875 10.1537C2.99062 10.135 2.02125 9.84813 1.2 9.39625C1.2 9.415 1.2 9.43937 1.2 9.46375C1.2 12.4525 3.33187 14.935 6.1275 15.5069C5.62687 15.6438 5.08125 15.7094 4.515 15.7094C4.12125 15.7094 3.72375 15.6869 3.35062 15.6044C4.1475 18.04 6.40875 19.8306 9.0975 19.8888C7.005 21.5256 4.34812 22.5119 1.47188 22.5119C0.9675 22.5119 0.48375 22.4894 0 22.4275C2.72438 24.1844 5.95312 25.1875 9.435 25.1875C20.7525 25.1875 26.94 15.8125 26.94 7.68625C26.94 7.41437 26.9306 7.15188 26.9175 6.89125C28.1381 6.025 29.1637 4.94313 30 3.69813Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.b463b7f9f9d2ef48a26e0b7319c495a3.svg";
export { ForwardRef as ReactComponent };